/** Interim until BE fixes redirect_uri in connect/initiate response */
export const INSTAGRAM_OAUTH_REDIRECT_ORIGIN = "https://alpha3.exlyapp.com";

export const INSTAGRAM_APIS = {
  connectInitiate: "users/instagram/connect/initiate",
  registration: "users/instagram/registration",
  selectAccount: "users/instagram/select/account",
  instagramStatus: "users/integrations/status/instagram",
  instagramDelink: "users/integrations/delink",
};

export const INSTAGRAM_CONNECT_STATUS = {
  AUTO_LINKED: "AUTO_LINKED",
  ACCOUNT_SELECTION_REQUIRED: "ACCOUNT_SELECTION_REQUIRED",
};

export const INSTAGRAM_CONNECT_URL_PARAMS = {
  status: "status",
  message: "message",
  account: "account",
  accounts: "accounts",
};

export const getInstagramConnectCallbackParamKeys = () =>
  Object.values(INSTAGRAM_CONNECT_URL_PARAMS);

export const INSTAGRAM_INTEGRATION_TOAST_MESSAGES = {
  get_account_connected: (username) => `@${username} connected successfully`,
  connect_success: "Instagram connected successfully",
  delink_success: "Instagram successfully delinked",
};

export const INSTAGRAM_INTEGRATION_ERROR_MESSAGES = {
  connect_redirect_failed:
    "useInstagram: failed during instagram connect redirect handling",
  connect_initiate_failed: "useInstagram: failed to initiate instagram connect",
  delink_failed: "useInstagram: failed to delink instagram account",
  select_account_failed: "useInstagram: failed to select instagram account",
};
